export default "__VITE_ASSET__56fc4361__"